/**
 * Coupon status info for feed coupon card
 */
export class CouponStatusInfo {
  /**
   * @constructor
   */
  constructor(
    public couponId: number,
    public selected: 'USED' | 'CANCELED' | '',
    public date?: Date,
    public invoice?: string,
    public discount?: number,
    public reseller?: string,
    public acknowledge?: boolean
  ) {}
}
